import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useFirebase } from "../contexts/FirebaseContext";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
	const { t } = useTranslation();
	const { user } = useFirebase();
	const location = useLocation();

	return (
		<header
			className={`sticky flex flex-row top-0 p-2 z-50 h-10 min-h-10 gap-2 items-center justify-between shadow-md bg-violet-950 text-violet-50`}>
			<Link
				to="/"
				className="flex flex-row gap-2 items-center">
				<div className="flex h-6 w-6 bg-white rounded items-center justify-center overflow-hidden">
					<img
						src="/IQM_logo.jpg"
						alt="IQM"
						className="h-full w-full object-contain"
					/>
				</div>
				<h1 className="text-base font-medium md:text-lg">{t("title")}</h1>
			</Link>

			<div className="flex flex-row gap-2">
				<LanguageSwitcher />

				{user && (
					<div
						className={`flex flex-row h-full w-12 justify-center items-center hover:text-violet-200 transition-colors`}>
						<Link to="/c/dashboard">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="currentColor"
								className="size-8">
								<path
									fillRule="evenodd"
									d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
									clipRule="evenodd"
								/>
							</svg>
						</Link>
					</div>
				)}
			</div>
		</header>
	);
};

export default Header;
